<template id="list-media">
    <div>
        <!-- List cms -->
        <div class="listCmsTag">
            <div class="row">
                <div class="col-md-4">
                    <h3>Product</h3>
                </div>
                <div class="col-md-8">
                    <general-searchbox
                        @searchButtonClick="setCurrentKeywordandSearch"
                    ></general-searchbox>
                </div>
            </div>
            <general-pagination
                v-if="paginate_data._infos._total && !showLoading"
                :paginate_data="paginate_data"
                @paginateItemClick="setCurrentPageAndSearch"
            ></general-pagination>
            <general-loading v-if="showLoading"></general-loading>
            <div class="row">
                <div class="col-md-12 text-right">
                    <button class="btn btn-primary" @click="syncSEOData">
                        สร้างข้อมูล SEO สำหรับสินค้าใหม่
                    </button>
                    <div>Thai {{ seo_amount.total_thai }} Items</div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div
                        class="card card-body mt-1"
                        v-for="item in items"
                        v-bind:key="'cbd' + item.id"
                    >
                        <div class="row">
                            <div class="col-md-2">
                                <a
                                    v-bind:href="
                                        base_item_url + '/detail/' + item.id
                                    "
                                    ><img
                                        :src="item.imgs.main"
                                        class="img-thumbnail"
                                        alt=""
                                /></a>
                            </div>
                            <div class="col-md-8">
                                <h4 class="text text-primary">
                                    <a
                                        v-bind:href="
                                            base_item_url + '/detail/' + item.id
                                        "
                                        >{{ item.code_in_store }}
                                        {{ item.name_in_store }}</a
                                    >
                                </h4>
                                <p class="text text-lg">
                                    &#xE3F;{{
                                        formatNumber(item.price_in_store)
                                    }}
                                </p>
                                <p v-if="item.brief != ''">
                                    breif {{ item.brief }}
                                </p>
                                <p v-if="item.detail != ''">
                                    detail {{ item.detail }}
                                </p>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group float-right">
                                    <a
                                        class="btn btn-light"
                                        v-bind:href="
                                            base_item_url + '/detail/' + item.id
                                        "
                                        >รายละเอียด</a
                                    >
                                </div>
                                <div class="form-group float-right">
                                    <button
                                        class="btn btn-primary"
                                        @click="navigateToEdit(item.id)"
                                    >
                                        แก้ไขรายละเอียดSEO
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <p>
                                    ชื่อหลัก: {{ item.common_code }}
                                    {{ item.name_in_common }}, category:
                                    {{ item.category.name }}
                                </p>
                                <span
                                    class="badge badge-success ml-1"
                                    v-for="(tag, tgId) in item.tags"
                                    v-bind:key="item.id + tgId + 'tag' + tag.id"
                                >
                                    {{ tag.key }}:{{ tag.value }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <general-pagination
                v-if="paginate_data._infos._total && !showLoading"
                :paginate_data="paginate_data"
                @paginateItemClick="setCurrentPageAndSearch"
            ></general-pagination>
            <div v-if="recordNotFound" class="alert alert-warning" role="alert">
                ไม่พบข้อมูล
            </div>
        </div>
        <!-- delete modal    -->
        <general-delete-modal
            @ConFirmDeleteClick="performDeleteItem"
        ></general-delete-modal>
        <!-- alert modal    -->
        <button
            style="display: none"
            type="button"
            class="btn btn-primary"
            data-toggle="modal"
            data-target="#AlertModal"
            ref="decoyAlertModalClick"
        >
            test
        </button>
        <general-alert-modal :alertMessage="alertMessage"></general-alert-modal>
    </div>
</template>

<script>
export default {
    props: {
        media_base_url: "",
    },
    data() {
        return {
            items: [],
            item: {},
            item_id: "",
            paginate_data: {
                _infos: {},
                _base_item_list_url: "",
            },
            alertMessage: {
                titleClassName: "warning",
                titleMessage: "แจ้งเตือน!!",
                bodyClassName: "warning",
                bodyMessage: "This is alert",
            },
            edit: false,
            recordNotFound: false,
            showLoading: true,
            formUrl: "/product/form",
            base_item_url: "/product",
            currentSearchKeyword: "",
            currentPage: 1,
            currentPerpage: 23,
            seo_list: [],
            seo_amount: {},
        };
    },
    mounted() {
        //console.log('Component mounted.')
    },
    created() {
        // this.fetchCmses();
        this.searchItems();
        this.getProductSeoAmount();
        // this.paginate_data._base_item_list_url = this.base_item_list_url;
    },
    methods: {
        setCurrentKeywordandSearch(searchKeyword) {
            this.currentPage = 1;
            this.currentSearchKeyword = searchKeyword;
            this.searchItems();
        },
        setCurrentPageAndSearch(page) {
            console.log("page:", page);
            this.currentPage = page;
            this.searchItems();
        },
        searchItems() {
            let url = this.base_item_url + "/list";
            url = url + "?page=" + this.currentPage;
            url = url + "&perpage=" + this.currentPerpage;
            url = url + "&keyword=" + this.currentSearchKeyword;
            console.log("url:", url);
            this.fetchItems(url);
        },
        fetchItems(url) {
            this.showLoading = true;
            this.items = [];
            url = url || this.base_item_url + "/list";
            axios
                .get(url)
                .then((response) => {
                    this.items = response.data.products.items;
                    this.paginate_data._infos =
                        response.data.products._infos._paginate;
                    this.paginate_data._infos._url_range = this.computePaginate(
                        this.paginate_data._infos._last_page
                    );
                    this.recordNotFound = this.items.length == 0 ? true : false;
                    this.showLoading = false;
                })
                .catch((errors) => {
                    console.log(errors);
                });
        },
        computePaginate(lastpage) {
            let result = [];
            let i = 0;
            let data = Object.entries(this.paginate_data._infos._url_range);
            // console.log(this.paginate_data._infos._last_page);
            data.forEach(function (item) {
                if (item[0] > 0 && item[0] <= lastpage) {
                    result[i] = item;
                    i++;
                }
            });
            // console.log(result);
            return result;
        },
        bytesTo(data, to, precision = 2) {
            //from https://www.geeksforgeeks.org/data-conversion-to-kb-mb-gb-tb-using-vue-js-filters/
            const const_term = 1024;
            if (to === "KB") {
                return (data / const_term).toFixed(precision) + "KB";
            } else if (to === "MB") {
                return (data / const_term ** 2).toFixed(precision) + "MB";
            } else if (to === "GB") {
                return (data / const_term ** 3).toFixed(precision) + "GB";
            } else if (to === "TB") {
                return (data / const_term ** 4).toFixed(precision) + "TB";
            } else {
                return "??";
            }
        },
        formatNumber(number_str) {
            return parseInt(number_str).toLocaleString();
        },
        setForDeleteItemId(item_id) {
            // console.log(item_id);
            this.item_id_for_delete = item_id;
        },
        performDeleteItem() {
            // console.log(this.item_id_for_delete);
            axios
                .post(
                    this.base_item_url +
                        "/" +
                        this.item_id_for_delete +
                        "/delete"
                )
                .then((response) => {
                    // console.log(response.data._infos)
                    this.searchItems();
                })
                .catch((errors) => {
                    if (errors.response.data._infos.result) {
                        this.alertMessage.bodyMessage =
                            errors.response.data._infos.result;
                        this.$refs.decoyAlertModalClick.click();
                    } else {
                        console.log(errors.response.data._infos.result);
                        alert("ไม่สามารถลบได้ " + errors.response.data);
                    }
                });
        },
        getProductSeoAmount() {
            this.seo_amount = {};
            const url = this.base_item_url + "/list-product-seo-amount";
            this.showLoading = true;
            axios
                .get(url)
                .then((response) => {
                    this.seo_amount = response.data._infos;
                    console.log("seo_amount", this.seo_amount);
                    this.showLoading = false;
                })
                .catch((errors) => {
                    console.log(errors);
                    this.showLoading = false;
                });
        },
        syncSEOData() {
            let sync_url = this.base_item_url + "/sync-product-seo";
            axios
                .post(sync_url)
                .then((response) => {
                    console.log(response);
                    window.location.reload();
                })
                .catch((errors) => {
                    console.log(errors.response.data);
                });
        },
        navigateToEdit(itemId) {
            window.location.href = this.base_item_url + "/edit/" + itemId;
        },
    },
};
</script>
